import { Injectable } from "@angular/core";
import { InsertReportFeedbackUsecase } from "../../domain/application/usecase/insert-report-feedback.usecase";
import { ReportUpdateOneByIdType } from "../../domain/gateway/report.gateway.interface";

@Injectable({
    providedIn: "root"
})
export class InsertReportFeedbackController {
    constructor(
        private readonly insertReportFeedbackUsecase: InsertReportFeedbackUsecase
    ) {}

    public async execute(input: ReportUpdateOneByIdType): Promise<void> {
        await this.insertReportFeedbackUsecase.execute(input);
    }
}
